import { useEffect, useState } from 'react';

export const useAnimation = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Temel animasyon variant'ları
  const fadeInUp = {
    hidden: { 
      opacity: 0, 
      y: 50,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: isMobile ? 0.4 : 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInRight = {
    hidden: { 
      opacity: 0, 
      x: -50,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { 
        duration: isMobile ? 0.4 : 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInLeft = {
    hidden: { 
      opacity: 0, 
      x: 50,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { 
        duration: isMobile ? 0.4 : 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInDown = {
    hidden: { 
      opacity: 0, 
      y: -50,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: isMobile ? 0.4 : 0.6,
        ease: "easeOut"
      }
    }
  };

  // Yeni gelişmiş animasyonlar
  const bounceIn = {
    hidden: { 
      opacity: 0, 
      scale: 0.3,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: isMobile ? 0.5 : 0.8,
        ease: "easeOut",
        type: "spring",
        bounce: 0.4
      }
    }
  };

  const slideInLeft = {
    hidden: { 
      opacity: 0, 
      x: -100,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { 
        duration: isMobile ? 0.5 : 0.8,
        ease: "easeOut"
      }
    }
  };

  const slideInRight = {
    hidden: { 
      opacity: 0, 
      x: 100,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { 
        duration: isMobile ? 0.5 : 0.8,
        ease: "easeOut"
      }
    }
  };

  const rotateIn = {
    hidden: { 
      opacity: 0, 
      rotate: -15,
      scale: 0.8,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      rotate: 0,
      scale: 1,
      transition: { 
        duration: isMobile ? 0.6 : 1,
        ease: "easeOut"
      }
    }
  };

  const scaleIn = {
    hidden: { 
      opacity: 0, 
      scale: 0.5,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: isMobile ? 0.5 : 0.7,
        ease: "easeOut"
      }
    }
  };

  const fadeOnly = {
    hidden: { 
      opacity: 0,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1,
      transition: { 
        duration: isMobile ? 0.6 : 1,
        ease: "easeOut"
      }
    }
  };

  const flipIn = {
    hidden: { 
      opacity: 0, 
      rotateY: -90,
      transition: { duration: 0 }
    },
    visible: { 
      opacity: 1, 
      rotateY: 0,
      transition: { 
        duration: isMobile ? 0.7 : 1.2,
        ease: "easeOut"
      }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: isMobile ? 0.15 : 0.2,
        delayChildren: 0.1
      }
    }
  };

  const staggerContainerSlow = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: isMobile ? 0.25 : 0.4,
        delayChildren: 0.2
      }
    }
  };

  return {
    isMobile,
    fadeInUp,
    fadeInRight,
    fadeInLeft,
    fadeInDown,
    bounceIn,
    slideInLeft,
    slideInRight,
    rotateIn,
    scaleIn,
    fadeOnly,
    flipIn,
    staggerContainer,
    staggerContainerSlow
  };
}; 